<template>
  <LayoutEmpty>
    <div
            id="splash"
    >
      <header>
        <div class="left">
          <div class="logo"></div>
        </div>
        <div class="right">
          <button
                  @click="goToLoginHandler"
          >
            {{$t('header.login')}}
          </button>
          <button
                  class="btn main"
                  @click="goToSubscribeHandler"
          >
            {{$t('header.subscribe')}}
          </button>
        </div>
      </header>
      <main>
        <div class="left">
          <div class="terms-box">
              <div class="header"></div>
            <div class="terms">
              <textarea
                      readonly
                      title="terms"
              >{{$t('splash.terms')}}</textarea>
            </div>
            <div class="buttons-container">
              <button
                      class="accept btn main"
                      type="button"
                      @click="acceptSplashHandler"
              >
                {{$t('splash.buttons.enter')}}
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  </LayoutEmpty>
</template>

<script>
  import LayoutEmpty from "../layouts/LayoutEmpty";

  const registerSplashAccepted = () => {
    localStorage.setItem('splashAccepted', true);
  };

  export default {
    components: {
      LayoutEmpty
    },
      methods:{
          leaveSplashHandler(){
              console.error('leave'); //TODO: Leave
          },
          acceptSplashHandler(){
              registerSplashAccepted();
              this.$router.push(window.splashRedirectIntended || {name: 'home'});
          },
          goToLoginHandler(){
            registerSplashAccepted();
            this.$router.push({name: 'login'});
          },
          goToSubscribeHandler(){
            registerSplashAccepted();
            this.$router.push({name: 'subscribe'});
          },
      }
  }
</script>

<style scoped lang="scss">
  @import './../styles/variables';

  #splash{
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    header{
      background-color: #000000;
      color: #ffffff;
      flex-grow: 0;
      height: 75px;
      display: flex;

      @media(max-width: 980px){
        height: auto;
        flex-direction: column;
      }

      .left{
        flex: 1;
      }

      .right{
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;

        @media(max-width: 980px){
          padding-bottom: 1em;
          text-align: center;
          height: 50px;
          width: 100%;
          display: block;
        }
      }

      button{
        padding: .5em 1em;
        margin: 0 .5em;
      }

      .logo{
        display: block;
        margin: 20px auto;
        height: 35px;
        width: 372px;
        background-image: url('/img/logo-white.png');
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;

        @media(max-width: 600px){
          margin: 0 25px;
          height: 100px;
          width: auto;
        }
      }
    }

    main{
      flex: 1;
      //background-image: url('/img/splash-background.jpg');
      //background-size: cover;
      //background-position-x: right;
      background: #ffffff;
      display: flex;

      h1,h2,h3,h4,h5,h6{
        margin: .33em 0;
      }

      .left{
        flex-basis: 100%;
        align-self: center;

        @media(max-width: 980px){
          flex-basis: 100%;
        }
  
  
        .header{
          display: block;
          margin: 20px auto;
          height: 35px;
          width: 372px;
          background-image: url('/img/logo-dark.png');
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
    
          @media(max-width: 600px){
            margin: 0 25px;
            height: 100px;
            width: auto;
          }
        }
        
        
        
        
        
        
        .terms-box{
          text-align: center;
          color: #000000;
          display: block;
          margin: 100px auto;
          width: 75%;
          min-width: 250px;
          max-width: 600px;
          min-height: 600px;
          background-color: rgba(255, 255, 255, .75);
          box-shadow: 0px 4px 8px rgba(0,0,0,.25);
          padding: 20px;

          @media(max-width: 900px){
            background-color: rgba(255, 255, 255, .75);
          }

          @media(max-width: 600px){
            width: auto;
            margin: 15px;
          }

          .terms{
            margin-top: 1.5em;
            padding: .75em;
            border-radius: .75em;
            background-color: lightgrey;

            textarea{
              width: 100%;
              height: 250px;
              resize: none;
              border: none;
              background-color: lightgrey;
              font-weight: bold;
              
              &:focus{
                outline-offset: 0;
                outline: none;
              }
            }
          }

          .buttons-container{
            margin-top: 75px;
            margin-bottom: 30px;
            padding: 0 15px;
            display: flex;
            flex-direction: column-reverse;

            @media(max-width: 600px){
              padding: 0;
              flex-direction: column-reverse;
            }

            button{
              font-size: 1em;
              font-weight: bold;
              padding: 1em;
              margin: .5em;
              

              @media(max-width: 600px){
                margin-top: .5em;
                margin-bottom: .5em;
              }
            }

            .accept{
              flex: 5;
            }

            .leave{
              flex: 2
            }
          }

          .slogan{
            text-transform: uppercase;
          }

          .subslogan{
            margin: 0;
          }

          .title{
            text-transform: uppercase;
          }
        }
      }
    }
  }
</style>
